import React from 'react';
import { createRoot } from 'react-dom/client';
import COMPONENTS from './components';

function mountAll() {
  document.querySelectorAll('[data-react]').forEach((node) => {
    const name = node.dataset.react;
    const Component = COMPONENTS[name];
    if (!Component) {
      console.warn(`No React component registered for "${name}"`);
      return;
    }
    let props = {};
    try {
      props = JSON.parse(node.dataset.props || '{}');
    } catch (e) {
      console.error(`Invalid JSON in data-props for ${name}`, e);
    }
    createRoot(node).render(<Component {...props} />);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountAll);
} else {
  mountAll();
}
